import { browserHistory } from "@common/helpers/browserHistory";
import { SportTypesIdsUrls } from "@racings/constants/enums/sportTypes";

export const goToRacingGame = ({ regionId, competitionId, gameId, racingType }) =>
	browserHistory.push(`/racings/${SportTypesIdsUrls[racingType]}/${regionId}/${competitionId}/${gameId}`);
